import { customAlphabet } from "nanoid";

import type {
  ModuleInput,
  ModuleInputSection,
  ModuleOnInputChange,
  ModuleOnInputChangeSection,
  ModuleOutput,
  ModuleOutputSection,
} from "ee/constants/ModuleConstants";
import { getNextEntityName } from "utils/AppsmithUtils";

const ALPHABET = "abcdefghijklmnopqrstuvwxyz";
const DEFAULT_INPUT_NAME = "input";
const DEFAULT_OUTPUT_NAME = "output";

export function generateUniqueId(existingIds?: string[]) {
  let newId;

  do {
    newId = customAlphabet(ALPHABET, 10)();
  } while ((existingIds || []).includes(newId));

  return newId;
}

export const generateNewInputGroup = (
  existingInputGroups: ModuleInput[] = [],
) => {
  const existingIds = existingInputGroups.map(({ id }) => id);
  const existingNames = existingInputGroups.map(({ label }) => label);
  const id = generateUniqueId(existingIds);
  const label = getNextEntityName(DEFAULT_INPUT_NAME, existingNames);

  return {
    id,
    label,
    propertyName: `input.${label}`,
    defaultValue: "",
    controlType: "INPUT_TEXT",
  };
};

export const generateNewOutputGroup = (
  existingOutputGroups: ModuleOutput[] = [],
) => {
  const existingIds = existingOutputGroups.map(({ id }) => id);
  const existingNames = existingOutputGroups.map(({ label }) => label);
  const id = generateUniqueId(existingIds);
  const label = getNextEntityName(DEFAULT_OUTPUT_NAME, existingNames);

  return {
    id,
    label,
    propertyName: `output.${label}`,
    value: "{{}}",
    controlType: "INPUT_TEXT",
  };
};

export const generateDefaultInputSection = (): ModuleInputSection => {
  return {
    id: generateUniqueId([]),
    sectionName: "",
    children: [],
  };
};

export const generateDefaultOutputSection = (): ModuleOutputSection => {
  return {
    id: generateUniqueId([]),
    sectionName: "",
    children: [],
  };
};

export const generateOnInputChangeSection = (): ModuleOnInputChangeSection => {
  return {
    id: generateUniqueId([]),
    sectionName: "",
    children: [],
  };
};

export const generateDefaultOnInputChange = (
  input: ModuleInput,
): ModuleOnInputChange => {
  return {
    id: generateUniqueId([]),
    value: "",
    inputId: input.id,
    controlType: "ACTION_SELECTOR",
    label: input.label,
  };
};
